var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.25C11.25 6.94036 10.6904 7.5 10 7.5C9.30964 7.5 8.75 6.94036 8.75 6.25C8.75 5.55964 9.30964 5 10 5C10.6904 5 11.25 5.55964 11.25 6.25Z",
    fill: "#6AD400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.375C11.25 8.68464 10.6904 8.125 10 8.125C9.30964 8.125 8.75 8.68464 8.75 9.375V13.75C8.75 14.4404 9.30964 15 10 15C10.6904 15 11.25 14.4404 11.25 13.75V9.375Z",
    fill: "#6AD400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM17.95 10C17.95 14.3907 14.3907 17.95 10 17.95C5.60934 17.95 2.05 14.3907 2.05 10C2.05 5.60934 5.60934 2.05 10 2.05C14.3907 2.05 17.95 5.60934 17.95 10Z",
    fill: "#6AD400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconInfo);
export default __webpack_public_path__ + "static/media/alerts_icon_info.771836e55a5a8426559baaa045306445.svg";
export { ForwardRef as ReactComponent };